module.exports = __webpack_public_path__ + "img/MIDCircle_Transparent.6fc13cbd.png";